
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { ShieldCheck, Users, AlertTriangle, DollarSign } from 'lucide-react';

interface StatsCardsProps {
  stats: {
    totalUsers: number;
    totalEscorts: number;
    pendingVerifications: number;
    pendingReports: number;
  };
}

const StatsCards: React.FC<StatsCardsProps> = ({ stats }) => {
  return (
    <div className="mb-8 grid grid-cols-1 md:grid-cols-4 gap-4">
      <Card>
        <CardContent className="pt-6">
          <div className="flex justify-between items-center">
            <div>
              <p className="text-sm text-muted-foreground">Total Users</p>
              <h3 className="text-2xl font-bold">{stats.totalUsers}</h3>
            </div>
            <div className="p-3 bg-primary/10 rounded-full">
              <Users className="h-5 w-5 text-primary" />
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="pt-6">
          <div className="flex justify-between items-center">
            <div>
              <p className="text-sm text-muted-foreground">Verification Requests</p>
              <h3 className="text-2xl font-bold">{stats.pendingVerifications}</h3>
            </div>
            <div className="p-3 bg-blue-500/10 rounded-full">
              <ShieldCheck className="h-5 w-5 text-blue-500" />
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="pt-6">
          <div className="flex justify-between items-center">
            <div>
              <p className="text-sm text-muted-foreground">Reported Content</p>
              <h3 className="text-2xl font-bold">{stats.pendingReports}</h3>
            </div>
            <div className="p-3 bg-amber-500/10 rounded-full">
              <AlertTriangle className="h-5 w-5 text-amber-500" />
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="pt-6">
          <div className="flex justify-between items-center">
            <div>
              <p className="text-sm text-muted-foreground">Revenue (Monthly)</p>
              <h3 className="text-2xl font-bold">€5,842</h3>
            </div>
            <div className="p-3 bg-green-500/10 rounded-full">
              <DollarSign className="h-5 w-5 text-green-500" />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default StatsCards;
